import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { IconZoomIn } from "@tabler/icons-react";
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableDocumentSupports = (props) => {
  // console.log(props.listEp)

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: "Aksi",
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => props.showDocument(row.id)}
            className="btn btn-danger btn-sm"
            type="button"
            title="LIHAT DOKUMEN"
          >
            <IconZoomIn stroke={2} />
          </button>
        </>
      ),
    },
    {
      name: "Nomor",
      width: "100px",
      selector: (row) => row.skor.variables_accreditation.elements_accreditation.Nomor,
    },
    {
      name: "Elemen Penilaian",
      width: "350px",
      cell: (row) => (
        <>
          {row.skor.variables_accreditation.Abjad.concat(". ").concat(
            row.skor.variables_accreditation.Deskripsi
          )}
        </>
      ),
    },
    {
      name: "Nama File",
      selector: (row) => row.namaFile,
    },
    {
      name: "Skor Self Assessment",
      selector: (row) =>
        row.skor?.skorSurveyor !== "" &&
          row.skor?.skorSurveyor !== null &&
          row.skor?.skorSurveyor !== undefined
          ? row.skor?.skorSurveyor
          : row.skor?.Skor,
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={props.documents}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Nomor, Elemen Penilaian & Nama File"
            className="w-50 form-control m-3"
            value={props.search}
            onChange={(e) => {
              const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s\.]/g, "");
              props.handleChangeSearch(cleanValue);
            }}
          />

        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableDocumentSupports;
